import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import DefaultInput from "../../components/inputs/defaultInput";
import DefaultButton from "../../components/buttons/defaultButton";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginUser, _resetLoginState } from "../../../store/slices/user.slice";
import toast from "react-hot-toast";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { HiOutlineMail, HiOutlineLockClosed } from "react-icons/hi";
import { FcGoogle } from "react-icons/fc";
import { FaFacebook } from "react-icons/fa";
import { HiOutlineArrowLeft, HiOutlineArrowRight } from "react-icons/hi";
import { HiOutlineWallet } from "react-icons/hi2";
import { HiPlus } from "react-icons/hi";
import LOGO from "../../assets/images/hr-logo.png";
import playstore from "../../assets/images/play-store.png";
import appstore from "../../assets/images/app-store.png";



const CAROUSEL_DOTS = 4;

const Login = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userStatus = useSelector((state) => state.user.status);
  const user = useSelector((state) => state?.user?.userInfo?.user || state?.user?.user);
  const { isAuthenticated, profileLoad } = useSelector((state) => state.user);
  const userError = useSelector((state) => state.user.error);
  const [showPassword, setShowPassword] = useState(false);
  const [carouselIndex, setCarouselIndex] = useState(0); // 0..3 for 4 dots
  const [cardRotationIndex, setCardRotationIndex] = useState(0); // 0,1,2 - cards cycle positions

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().trim().required("Username is required"),
      password: Yup.string().trim().required("Password is required"),
    }),
    onSubmit: (values) => {
      dispatch(loginUser(values));
    },
  });

  const handleInputChange = (e) => {
    formik.handleChange(e);
    if (userStatus === "failed") {
      dispatch(_resetLoginState());
    }
  };

  useEffect(() => {
    if (userStatus === "succeeded" && isAuthenticated) {
      if (!profileLoad) {
        navigate("/");
        toast.success("Login successful!");
      }
    } else if (userStatus === "failed" && userError) {
      toast.dismiss();
      toast.error(
        userError ||
        "Invalid credentials. Please check your input and try again."
      );
    }
  }, [userStatus, user, isAuthenticated, userError, profileLoad, navigate]);

  useEffect(() => {
    return () => {
      dispatch(_resetLoginState());
    };
  }, [dispatch]);

  // Cards rotate positions: Card1→pos2, Card2→pos3, Card3→pos1 (continuous loop - slow & smooth)
  useEffect(() => {
    const t = setInterval(() => {
      setCardRotationIndex((i) => (i + 1) % 3);
    }, 2500);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="min-h-screen w-full grid grid-cols-1 md:grid-cols-2 ">
      {/* Left section - illustrative content (match screenshot) */}
      <div className="hidden lg:flex flex-1 flex-col p-8 lg:p-16 bg-gray-100">
        <div className="flex">
          <div className="mb-0 flex items-center gap-2">
          <img src={LOGO} alt="Logo" className=" h-12" />
          </div>
        </div>

        {/* Three cards: rotate positions – left/top/width/height animated so move is visible */}
        <div className="relative flex-1 flex items-center justify-center min-h-[320px]">
          <div className="relative w-[400px] h-[320px]">
            {(() => {
              const SLOTS = [
                { left: 64, top: 0, width: 200, height: 130, zIndex: 10 },
                { left: 220, top: 64, width: 180, height: 140, zIndex: 20 },
                { left: 0, top: 180, width: 300, height: 120, zIndex: 0 },
              ];
              const getSlot = (cardIndex) => SLOTS[(cardIndex + cardRotationIndex) % 3];
              const baseClass = "absolute rounded-xl transition-all duration-1000 ease-in-out";
              const s0 = getSlot(0), s1 = getSlot(1), s2 = getSlot(2);
              return (
                <>
                  <div
                    className={`${baseClass} bg-white shadow-lg border border-gray-100 p-4 flex flex-col`}
                    style={{
                      left: s0.left,
                      top: s0.top,
                      width: s0.width,
                      height: s0.height,
                      zIndex: s0.zIndex,
                    }}
                  >
                    <div className="w-9 h-9 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0">
                      <HiOutlineWallet className="w-5 h-5 text-blue-500" />
                    </div>
                    <p className="text-[11px] font-medium text-gray-500 uppercase tracking-wider mt-3">Current Balance</p>
                    <p className="text-2xl font-bold text-blue-600 mt-1 pb-2">$24,359</p>
                  </div>
                  <div
                    className={`${baseClass} bg-white shadow-lg border border-gray-100 p-4 flex flex-col items-center justify-center`}
                    style={{
                      left: s1.left,
                      top: s1.top,
                      width: s1.width,
                      height: s1.height,
                      zIndex: s1.zIndex,
                    }}
                  >
                    <div className="relative w-20 h-20 flex-shrink-0">
                      <svg viewBox="0 0 36 36" className="w-20 h-20 -rotate-90">
                        <circle cx="18" cy="18" r="15.5" fill="none" stroke="#1E40AF" strokeWidth="4.5" strokeDasharray="53.6 97.4" />
                        <circle cx="18" cy="18" r="15.5" fill="none" stroke="#F97316" strokeWidth="4.5" strokeDasharray="24.35 97.4" strokeDashoffset="-53.6" />
                        <circle cx="18" cy="18" r="15.5" fill="none" stroke="#22C55E" strokeWidth="4.5" strokeDasharray="19.45 97.4" strokeDashoffset="-77.95" />
                      </svg>
                      <div className="absolute inset-0 flex flex-col items-center justify-center">
                        <span className="text-xs font-semibold text-gray-700 leading-tight">34%</span>
                        <span className="text-[10px] text-gray-500 leading-tight">Food</span>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`${baseClass} bg-white border-2 border-dashed border-gray-300 p-5 flex flex-col items-center justify-center`}
                    style={{
                      left: s2.left,
                      top: s2.top,
                      width: s2.width,
                      height: s2.height,
                      zIndex: s2.zIndex,
                    }}
                  >
                    <div className="w-11 h-11 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
                      <HiPlus className="w-6 h-6 text-blue-500" />
                    </div>
                    <p className="text-sm font-medium text-gray-600 mt-3">New transaction</p>
                    <p className="text-xs text-gray-400 mt-0.5">or upload .xls file</p>
                  </div>
                </>
              );
            })()}
          </div>
        </div>

        <div className="mt-auto pt-4">
          <h1 className="text-3xl font-bold text-gray-900">Welcome back!</h1>
          <p className="text-gray-600 text-base mb-5">Get insights that help you save more</p>

        </div>
      </div>

      {/* Right section - Login form */}
      <div className="w-full flex-shrink-0 relative bg-white flex flex-col items-center justify-center p-8 md:p-12">
        <div className="w-full max-w-[28rem] ">
          <h1 className="text-3xl font-bold text-gray-900">Hi, Will you Sign in now!</h1>
          <p className="text-gray-600 mt-1 mb-8">
            Welcome back
          </p>

          <form
            onSubmit={formik.handleSubmit}
            className="flex flex-col gap-5"
          >
            <DefaultInput
              error={
                formik.touched.username && formik.errors.username
                  ? formik.errors.username
                  : ""
              }
              name="username"
              onChange={handleInputChange}
              value={formik.values.username}
              placeholder="you@example.com"
              label="Username"
              labelClass="text-gray-700"
              leftIcon={<HiOutlineMail className="w-5 h-5" />}
              classnames="border-gray-200 bg-gray-50"
            />
            <DefaultInput
              name="password"
              type={showPassword ? "text" : "password"}
              onChange={handleInputChange}
              value={formik.values.password}
              placeholder="At least 8 characters"
              label="Password"
              labelClass="text-gray-700"
              leftIcon={<HiOutlineLockClosed className="w-5 h-5" />}
              classnames="border-gray-200 bg-gray-50"
              error={
                formik.touched.password && formik.errors.password
                  ? formik.errors.password
                  : ""
              }
              rightIcon={
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="cursor-pointer text-gray-500 hover:text-gray-700 transition-colors"
                >
                  {showPassword ? (
                    <AiOutlineEyeInvisible size={20} />
                  ) : (
                    <AiOutlineEye size={20} />
                  )}
                </button>
              }
            />

            <div className="flex justify-end -mt-1">
              <Link
                to="/auth/forgot"
                className="text-sm font-medium text-blue-600 hover:text-blue-700"
              >
                Forgot password?
              </Link>
            </div>

            <DefaultButton
              type="submit"
              disabled={userStatus === "loading" || profileLoad}
              loading={userStatus === "loading" || profileLoad}
              name={userStatus !== "loading" && !profileLoad ? "Login" : ""}
            />
          </form>

          <div className="flex items-center gap-4 my-6">
            <div className="flex-1 h-px bg-gray-200" />
            <span className="text-sm text-gray-500">Explore Our App</span>
            <div className="flex-1 h-px bg-gray-200" />
          </div>

          <div className="flex gap-3 items-center justify-center">
            <button
              type="button"
              onClick={() => window.open("https://play.google.com/store/apps/details?id=com.hr.bydo&pcampaignid=web_share", "_blank")}
            >
              <img src={playstore} alt="playstore" className=" h-10 border border-borderColor rounded-lg" />
            </button>
            <button
              onClick={() => window.open("https://play.google.com/store/apps/details?id=com.hr.bydo&pcampaignid=web_share", "_blank")}
              type="button"
            >
              <img src={appstore} alt="app-store" className=" h-10 border border-borderColor rounded-lg" />

            </button>
          </div>

          <p className="text-center text-xs text-gray-400 absolute bottom-8 left-0 right-0">
            © {new Date().getFullYear()} ALL RIGHTS RESERVED
          </p>
        </div>
      </div>

      {/* Mobile: bydo.io branding */}
      <div className="lg:hidden absolute top-10 left-6 z-10 flex items-center gap-2">
      <img src={LOGO} alt="Logo" className="h-12" />
      </div>
    </div>
  );
};

export default Login;